import React from 'react';
import { useCart } from './CartContext';
import Toastify from 'toastify-js';
import 'toastify-js/src/toastify.css';

const AddToCartButton = ({ itemId, itemType }) => {
  const { addItem } = useCart();
  const csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const addToCart = async () => {
    const data = {
      item_type: itemType,
      item_id: itemId,
      authenticity_token: csrfToken
    };

    try {
      await addItem(data);

      Toastify({
        text: "Item added to cart successfully.",
        duration: 3000,
        close: true,
        gravity: "top",
        position: "right",
        className: "info",
        stopOnFocus: true
      }).showToast();

    } catch (error) {
      console.error('There was a problem with your fetch operation:', error);
      Toastify({
        text: "There was an issue adding the item to the cart.",
        duration: 3000,
        close: true,
        gravity: "top",
        position: "right",
        className: "error",
        stopOnFocus: true
      }).showToast();
    }
  };

  return (
    <button className="action-button" onClick={addToCart}>
      Add to Cart
    </button>
  );
};

export default AddToCartButton;
